
import {Component, Mixins, Prop} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import NoterPicker from "@/components/pickers/NoterPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Faizler from "@/components/forms/Faizler.vue";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {TakipEntity} from "@/entity/TakipEntity";

import {TakipDurumu} from "@/enum/TakipDurumu";

@Component({
  components: {Tutar, Dates, NoterPicker, FormWrapper, Faizler},
})
export default class ProtestoIhtar extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean | string;
  @Prop() tur!: string;
  @Prop() alacak !: any;
  @Prop() ihtarTuru !: any;

  get takip(): TakipEntity {
    const route = this.$route.path;
    if (route.includes('/icrapro/takip/') && !route.includes('/takip-ekle/')) {
      return this.$store.getters['takipDetay/takip'];
    }
    return this.$store.getters['takipEkle/item'];
  }

  get takipTarihi() {
    const val = this.takip?.takip_tarihi || this.takip?.takip_bilgileri?.takip_tarihi;
    if (!val) return null;
    return new Date(val).toISOString().substr(0, 10);
  }

  get dateRules() {
    return [
      (v: any) => !!v || 'Lütfen bu alanı doldurun.',
      (v: any) => {
        if (!v || !this.takipTarihi) return true;
        const norm = String(v).includes('.') ? v.split('.').reverse().join('-') : v;
        const girilenDate = new Date(norm);
        const takipDate = new Date(this.takipTarihi);
        return this.$helper.tarihFarkiGunSayisi(takipDate, girilenDate) <= 0 || 'Tarih takip tarihinden büyük olamaz.';
      }
    ];
  }

  save() {
    if (this.loading) return;
    this.loading = true;
    const isProtesto = String(this.ihtarTuru) === 'protesto';

    // Ortak payload
    const body: any = {
      ...this.localValue,
      alacak_id: this.alacak?.id ?? this.localValue.alacak_id,
      para_birimi_id: this.localValue.para_birimi_id ?? 1,
    };

    if (!this.alacak?.id) {
      this.$emit('addIhtar', body);
      this.$emit('addProtesto', body);
      this.$emit('onSuccess');
      this.loading = false;
      return;
    }

    const doEmitSuccess = (payload:any) => {
      this.$emit('addIhtar', payload);
      this.$emit('addProtesto', payload);
      this.$emit('onSuccess');
    };

    if (body.id) {
      const { gecikme_tazminati_mi, ...payload } = body;
      this.$http.put(`/api/v1/alacak-kalemi/${body.id}`, payload)
          .then(() => doEmitSuccess(body))
          .catch(err => { this.$emit('onError', err); })
          .finally(() => { this.loading = false; });
    } else {
      const path = isProtesto ? 'protesto' : 'ihtar';
      const { gecikme_tazminati_mi, ...payload } = body;
      this.$http.post(`/api/v1/alacak/${this.alacak.id}/${path}`, payload)
          .then((res:any) => {
            if (res?.data?.id) this.localValue.id = res.data.id; // id'yi modele yansıt
            doEmitSuccess(this.localValue);
          })
          .catch(err => { this.$emit('onError', err); })
          .finally(() => { this.loading = false; });
    }
  }



  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }
}
